import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trackGtm } from '../../utils';

import addIconTeal from '../../../content/media-library/icons/add-icon-teal.svg';

export const buttonTypes = ['Action', 'Onboarding Flow Link'];

const CTAButton = (props) => {
  const {
    type,
    text,
    link,
    colourScheme,
    icon,
    id,
    className,
    onClick,
    hideOnMobile,
    hideOnDesktop,
    align,
    scrollTarget,
    newTab,
    webflowRoute,
    placement,
    focusColour,
    trackingIdentifier
  } = props;

  const getAbsoluteHeight = (el) => {
    el = typeof el === 'string' ? document.querySelector(el) : el;
    const styles = window.getComputedStyle(el);
    const margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
    return Math.ceil(el.offsetHeight + margin);
  };

  const scrollAction = (e) => {
    e.preventDefault();
    if (!document.querySelector(scrollTarget)) return;

    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: document.querySelector(scrollTarget).offsetTop - getAbsoluteHeight('[data-sitenavigation]') + 1
    });
  };

  const handleClick = () => {
    if (typeof window === 'undefined') return;

    const position = window.scrollY || window.pageYOffset;
    const percentage = (position / document.body.scrollHeight) * 100;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ctaButtonClicked',
        buttonText: text ? text : 'Get the app',
        scrollPosition: `${percentage.toFixed(2)}%`,
        trackingIdentifier
      });
      if ((webflowRoute || (link && link.includes('/apply/'))) && placement) {
        trackGtm({
          event: 'onboarding_cta_click',
          placement
        });
      }
    }
  };

  switch (type) {
    case 'Onboarding Flow Link': {
      return (
        <div id={id} className={className}>
          <a
            href={link || `/apply/${webflowRoute === 'default' ? '' : `?r=${webflowRoute}`}`}
            className="cta-button cta-button--teal-scheme btn-download-app"
            onClick={handleClick}
          >
            {text || 'Apply now'}
          </a>
        </div>
      );
    }
    case 'Action': {
      const componentClasses = classNames(
        className,
        'cta-button',
        'cta-button--load-more',
        {
          [`cta-button--${colourScheme}-scheme`]: colourScheme
        },
        {
          [`cta-button--${focusColour}-focus`]: focusColour
        }
      );
      return (
        <button className={componentClasses} id={id} onClick={onClick}>
          {text}
          <img alt="Plus icon" src={addIconTeal} />
        </button>
      );
    }
    default: {
      const componentClasses = classNames(className, 'cta-button', {
        [`cta-button--${colourScheme}-scheme`]: colourScheme,
        'cta-button--hide-on-mobile': hideOnMobile,
        'cta-button--hide-on-desktop': hideOnDesktop,
        [`cta-button--${align}`]: align,
        [`cta-button--${focusColour}-focus`]: focusColour
      });
      return (
        <a
          className={componentClasses}
          href={link}
          id={id}
          onClick={(e) => {
            if (scrollTarget) scrollAction(e);
            handleClick();
          }}
          target={newTab ? `_blank` : `_self`}
          rel={newTab ? `noopener noreferrer` : null}
        >
          {icon ? <span className={icon} /> : ''}
          {text}
        </a>
      );
    }
  }
};

CTAButton.propTypes = {
  type: PropTypes.oneOf(buttonTypes),
  text: PropTypes.string,
  link: PropTypes.string,
  colourScheme: PropTypes.oneOf(['teal', 'white', 'purple', 'ghost-white', 'ghost-purple', 'sand']),
  icon: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  hideOnMobile: PropTypes.string,
  hideOnDesktop: PropTypes.string,
  align: PropTypes.oneOf(['left', 'left-centre']),
  scrollTarget: PropTypes.string,
  newTab: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  webflowRoute: PropTypes.oneOf(['default', 'pca', 'bca', 'sta']),
  placement: PropTypes.string,
  focusColour: PropTypes.oneOf(['orange']),
  trackingIdentifier: PropTypes.string
};

export const CTAButtons = ({ callToAction }) => {
  if (!callToAction) return null;
  return callToAction.map((cta, i) => <CTAButton key={`button_${i}`} {...cta} />);
};

CTAButtons.propTypes = {
  callToAction: PropTypes.arrayOf(PropTypes.shape(CTAButton.propTypes))
};

export default CTAButton;
